import { useEffect } from 'react';

type UseBeforeUnloadOptions = {
  enabled: boolean;
  onBeforeUnload: (event: BeforeUnloadEvent) => unknown;
};

export function useBeforeUnload({
  enabled,
  onBeforeUnload,
}: UseBeforeUnloadOptions) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handler = (event: BeforeUnloadEvent) => {
      onBeforeUnload?.(event);
    };

    window.addEventListener('beforeunload', handler);
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [enabled, onBeforeUnload]);
}
